<div class="screener-box" [class]="screenerConfig.status">
  @switch (screenerConfig.status) {
    @case ('complete-near-pass-accepted') {
      <mat-icon class="icon" fontSet="material-icons-outlined"> thumb_up </mat-icon>
    }
    @case ('complete-passed') {
      <mat-icon class="icon" fontSet="material-icons-outlined"> thumb_up </mat-icon>
    }
    @case ('complete-failed') {
      <mat-icon class="icon" fontSet="material-icons-outlined"> thumb_down </mat-icon>
    }
    @case ('complete-near-pass') {
      <mat-icon class="icon" fontSet="material-icons-outlined"> call_missed </mat-icon>
    }
    @case ('complete') {
      <mat-icon class="icon" fontSet="material-icons-outlined"> pending </mat-icon>
    }
    @default {
      <mat-icon class="icon" fontSet="material-icons-outlined"> send </mat-icon>
    }
  }

  <div class="screener-info">
    <div>
      <span>Sent On:</span>
      {{ screenerConfig.dateSent | date: 'mediumDate' }}
      {{ screenerConfig.dateSent | date: 'shortTime' }}
    </div>
    @if (screenerConfig.dateCompleted) {
      <div>
        <span>Completed On:</span>
        {{ screenerConfig.dateCompleted | date: 'mediumDate' }}
        {{ screenerConfig.dateCompleted | date: 'shortTime' }}
      </div>
    }
  </div>

  @if (screenerConfig.dateCompleted) {
    <mat-icon class="eye"> visibility </mat-icon>
  }
  @if (!screenerConfig.dateCompleted) {
    <mat-icon class="eye"> visibility_off </mat-icon>
  }
</div>
